__turbopack_context__.v({
  "section-text-two-images": "_4mJh7G_section-text-two-images",
  "section-text-two-images__images": "_4mJh7G_section-text-two-images__images",
  "section-text-two-images__inner": "_4mJh7G_section-text-two-images__inner",
  "section-text-two-images__text": "_4mJh7G_section-text-two-images__text",
});
